import { Uuid } from "@legacy-megarax/common";
import { NewRouterResponsiveSelect } from "@legacy-megarax/ui-components";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { getMegaraxPath } from "@megaron/megarax-uri";

export type CustomerOption = {
  uuid: Uuid;
  name: string | null;
};

export type GetCustomerOptions = (search: string) => Promise<CustomerOption[]>;

export type OnComplete = (formData: { customerUuid: Uuid }) => void;

interface Props {
  onClose: () => void;
  isOpen: boolean;
  getCustomerOptions: GetCustomerOptions;
}

export const AddUnplannedVisitDialog: React.FunctionComponent<Props> = ({ onClose, isOpen, getCustomerOptions }) => {
  const classes = useStyles();

  const navigate = useNavigate();

  const [customerUuid, setCustomerUuid] = React.useState<Uuid | null>(null);

  const isFormFilledIn = customerUuid !== null;

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Nieplanowana wizyta</DialogTitle>
      <DialogContent className={classes.content}>
        <div className={classes.form}>
          <NewRouterResponsiveSelect
            getOptions={getCustomerOptions}
            getKey={(o) => o.uuid}
            getLabel={(o) => o.name ?? "?"}
            getValue={(o) => o.uuid}
            onChange={setCustomerUuid}
            value={customerUuid}
            label="Klient"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          disabled={!isFormFilledIn}
          onClick={() =>
            customerUuid &&
            navigate(
              `${getMegaraxPath.uri("megarax://crm/customers/id/{id}", { id: customerUuid })}/add-interaction?tab=historia`,
            )
          }
        >
          Dalej
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => ({
  content: {
    minWidth: "200px",
  },

  form: {
    "& > *": {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
}));
